import { useRecoilCallback } from 'recoil';
import { ITripsOverViewRecord } from '../interfaces';
import {
  rideInfoRecordsAtom,
  rideItemAtom,
  rideItemIdsAtom,
  rideItemTimestampsAtom,
} from '../TripsOverviewState';

interface IUseTable {
  setRideItemsState: (data: ITripsOverViewRecord[]) => void;
  setRideInfoRecordsState: (data: ITripsOverViewRecord[]) => void;
  updateRideItemsState: (data: ITripsOverViewRecord[]) => void;
  resetRideItemsState: () => void;
}

const useTable = (): IUseTable => {
  /** Sets recoil state for every ride record item */
  const setRideItemsState = useRecoilCallback(({ set }) => async (data: ITripsOverViewRecord[]) => {
    const ids: string[] = [];
    data.forEach((rideItem: ITripsOverViewRecord) => {
      ids.push(rideItem.id);
      set(rideItemAtom(rideItem.id), () => rideItem);
    });
    set(rideItemIdsAtom, ids);
  });

  const updateRideItemsState = useRecoilCallback(
    ({ set, snapshot }) =>
      async (data: ITripsOverViewRecord[]) => {
        const ids: string[] = [];
        const timestamps: string[] = [];
        data.forEach((rideItem: ITripsOverViewRecord) => {
          ids.push(String(rideItem.id));
          timestamps.push(rideItem.timestamp.start);
          set(rideItemAtom(String(rideItem.id)), () => rideItem);
        });
        const rideItemIds = await snapshot.getPromise(rideItemIdsAtom);
        if (data[0] && !rideItemIds.includes(String(data[0].id))) {
          const rideItemTimestamps = await snapshot.getPromise(rideItemTimestampsAtom);
          const newRideItemIds: string[] = [...rideItemIds, ...ids];
          set(rideItemIdsAtom, newRideItemIds);
          const newRideItemTimestamps: string[] = [...rideItemTimestamps, ...timestamps];
          set(rideItemTimestampsAtom, newRideItemTimestamps);
        }
      }
  );

  const setRideInfoRecordsState = useRecoilCallback(({ set }) => (data: ITripsOverViewRecord[]) => {
    const ids: string[] = [];
    data.forEach((item: ITripsOverViewRecord) => {
      ids.push(item.id);
      set(rideInfoRecordsAtom(item.id), () => item.info.records);
    });
    // set(TripsOverviewState.rideItemIds, ids);
  });
  const resetRideItemsState = useRecoilCallback(({ reset, snapshot }) => async () => {
    const rideItemIds = await snapshot.getPromise(rideItemIdsAtom);
    rideItemIds.forEach((rideItem: string) => {
      reset(rideItemAtom(rideItem));
    });
    reset(rideItemIdsAtom);
  });

  const data = {
    setRideItemsState,
    setRideInfoRecordsState,
    updateRideItemsState,
    resetRideItemsState,
  };

  return data;
};

export default useTable;
